var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"width":"610"},model:{value:(_vm.open),callback:function ($$v) {_vm.open=$$v},expression:"open"}},[_c('task-card',{attrs:{"task":_vm.task,"description-height":280,"can-interact":_vm.canInteract}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }